import { Component, OnInit } from '@angular/core';
import { InterfaceConfigService } from './interface-config.service';

@Component({
  selector: 'app-interface-config',
  templateUrl: './interface-config.component.html',
  styleUrls: ['./interface-config.component.css'],
})
export class InterfaceConfigComponent implements OnInit {

  interfaceApiList: any[] = [];  

  constructor(private interfaceConfigService: InterfaceConfigService) { }

  ngOnInit(): void {
    this.loadInterfaceApiList();
  }

  loadInterfaceApiList(): void {
    this.interfaceConfigService.getInterfaceApiList()
      .then(data => {
        console.log('Interface API list loaded:', data);
        this.interfaceApiList = data;
      })
      .catch(err => {
        console.error('Failed to load interface API list', err);
      });
  }

  formatDate(dateString: string): string {
    if (!dateString) {
      return '-';
    }
  
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return '-';
    }
  
    const day = date.getDate().toString().padStart(2, '0'); 
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();
  

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; 
    const hoursStr = hours.toString().padStart(2, '0');
  
    return `${day}- ${month}- ${year} ${hoursStr}:${minutes} ${ampm}`;
  }
  

}


// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/interface-config/interface-config.component.ts